import React, { useState } from 'react';
import { ArrowRight, Star, ShieldCheck, Mail, Loader2 } from 'lucide-react';
const CHECKOUT_URL = 'https://the-basketball-coach-s-bible.impultienda.ar/checkout';
export function FinalCTA() {
  const [loading, setLoading] = useState(false);
  const handleClick = () => {
    setLoading(true);
    setTimeout(() => setLoading(false), 6000);
  };
  return <section className="bg-gradient-to-b from-bb-charcoal to-bb-dark py-20 px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-68">
      <div className="absolute inset-0 court-lines opacity-[0.06] pointer-events-none" data-id="element-69"></div>
      <div className="absolute top-0 left-0 w-96 h-96 bg-bb-orange/20 rounded-full blur-3xl" data-id="element-70"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-bb-orange/10 rounded-full blur-3xl" data-id="element-71"></div>

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-72">
        <div className="bg-bb-orange/20 backdrop-blur-sm border border-bb-orange/40 text-bb-orange-light font-bold text-xs px-4 py-1.5 rounded-full mb-6 inline-block uppercase tracking-[0.2em]" data-id="element-73">
          Final Call
        </div>

        <h2 className="font-display font-bold uppercase text-3xl sm:text-4xl md:text-5xl text-white leading-tight mb-5 tracking-tight" data-id="element-74">
          Your players deserve the best version of you, not an{' '}
          <span className="text-bb-orange" data-id="element-75">overwhelmed one</span>
        </h2>

        <p className="text-white/85 text-lg mb-10 max-w-xl mx-auto leading-relaxed" data-id="element-76">
          Stop spending your Sundays stressing over drills. Take control of your
          season with the elite tools you deserve.
        </p>

        <div className="bg-white/5 backdrop-blur-sm border border-white/15 rounded-2xl p-6 mb-6 max-w-sm mx-auto" data-id="element-77">
          <p className="text-white/80 text-sm mb-2" data-id="element-78">
            Pack 6-in-1: Coach's Bible + 5 Premium Bonuses
          </p>
          <p className="text-white/70 text-sm mb-1" data-id="element-79">
            <span className="line-through" data-id="element-80">$97</span>
          </p>
          <p className="text-white/85 text-sm mb-1" data-id="element-81">Only:</p>
          <div className="flex items-baseline justify-center gap-2" data-id="element-82">
            <p className="font-display font-bold text-6xl sm:text-7xl text-bb-orange leading-none" data-id="element-83">
              $27
            </p>
            <span className="font-display font-bold text-2xl sm:text-3xl text-bb-orange leading-none" data-id="element-84">
              USD
            </span>
          </div>
          <p className="text-white/70 text-xs mt-2 italic" data-id="element-85">
            You'll be charged in your local currency at checkout.
          </p>
        </div>

        <a href={CHECKOUT_URL} target="_blank" rel="noopener" onClick={handleClick} aria-busy={loading} className={`group inline-flex items-center justify-center gap-3 bg-bb-orange hover:bg-bb-orange-dark text-white font-bold uppercase tracking-wide text-base sm:text-lg py-4 px-8 sm:px-12 rounded-full shadow-[0_15px_40px_rgba(234,88,12,0.5)] hover:shadow-[0_20px_50px_rgba(234,88,12,0.7)] hover:-translate-y-1 transition-all duration-300 w-full sm:w-auto ${loading ? 'opacity-90 pointer-events-none' : ''}`} data-id="element-86">
          {loading ? <>
              <Loader2 className="w-5 h-5 animate-spin" data-id="element-87" />
              <span data-id="element-88">Opening Checkout…</span>
            </> : <>
              <span data-id="element-89">🏀 Yes, I Want the Complete System</span>
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-90" />
            </>}
        </a>

        <div className="mt-6 flex flex-col items-center gap-2" data-id="element-91">
          <div className="flex items-center gap-2 text-white/85 text-sm" data-id="element-92">
            <Mail className="w-4 h-4 text-bb-orange" data-id="element-93" />
            <span data-id="element-94">Immediate Access — Instant Digital Delivery</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-95">
            <div className="flex text-bb-orange" data-id="element-96">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4" fill="currentColor" data-id="element-97" />)}
            </div>
            <span className="text-white/90 text-sm font-medium" data-id="element-98">
              4.9/5 — Verified Reviews
            </span>
          </div>
          <div className="flex items-center gap-2 text-white/80 text-sm" data-id="element-99">
            <ShieldCheck className="w-4 h-4 text-bb-orange" data-id="element-100" />
            <span data-id="element-101">30-Day Money-Back Guarantee — ZERO Risk</span>
          </div>
        </div>
      </div>
    </section>;
}